import { createStore } from "vuex";
import loading from "@/store/modules/loading";

export default createStore({
  modules: {
    loading,
  },
  state: {
    countryCode: "de",
  },
  getters: {
    countryCode: (state) => state.countryCode,
  },
  mutations: {
    setCountryCode(state, newCountryCode: string) {
      state.countryCode = newCountryCode;
    },
  },
});
